export const KEY_VALUES = {
  UP: 'ArrowUp',
  DOWN: 'ArrowDown',
  ENTER: 'Enter',
  TAB: 'Tab',
  BACKSPACE: 'Backspace',
  ESC: 'Escape',
}

export const PICKER_TEXT = {
  close: 'Close',
  noResults: 'No results found',
  placeholder: 'Select',
  searchPlaceholder: 'Search',
}

export const MENU_MAX_HEIGHT = 320

export const FADE_TIMEOUT = 300

export const TRANSITION_END_EVENT = 'transitionend'

export const ICON_SIZE = '1em'
